import React from 'react';
import ComponentSkinWrapper from '../../skins/ComponentSkinWrapper';
import { CategoryMenuSkinnable } from './CategoryMenuSkinnable';
import { COMPONENT_TYPES } from '../../../constants';
import { CategoryMenuProps } from './CategoryMenu.types';

/**
 * 카테고리 메뉴 컴포넌트 (레거시 호환용)
 * 스킨 시스템을 사용하여 외부 스킨 적용이 가능합니다.
 */
const CategoryMenuComponent: React.FC<CategoryMenuProps> = (props) => {
  // ComponentData 구성
  const componentData = {
    id: props.id || `${COMPONENT_TYPES.CATEGORY_MENU}-${Date.now()}`,
    type: COMPONENT_TYPES.CATEGORY_MENU,
    componentProps: props.componentProps || {},
    props: props,
    theme: (props as any).theme || {},
    externalSkin: props.externalSkin
  };
  

  
  // URL 기반으로 프리뷰 모드 감지
  const isInPreview = window.location.pathname.includes('/preview') || 
                      window.location.pathname.includes('/share') ||
                      window.location.search.includes('preview=true');
  
  // 렌더 모드 결정 (URL 기반 프리뷰 체크 추가)
  const mode = isInPreview ? 'preview' :
               props.isPreview ? 'preview' : 
               props.isEditor ? 'editor' : 'production';
               

  // 에디터 props (필요한 경우)
  const editorProps = props.isEditor ? {
    isSelected: (props as any).isSelected,
    onSelect: (props as any).onSelect,
    onEdit: (props as any).onEdit,
    onDelete: (props as any).onDelete
  } : undefined;
  
  return (
    <ComponentSkinWrapper
      component={CategoryMenuSkinnable}
      componentData={componentData}
      mode={mode}
      editorProps={editorProps}
    />
  );
};

export default CategoryMenuComponent;